import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import CTAWrapper from '../CTAWrapper'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Pill from 'srcReact/components/common2/Pill'
import Icon from 'srcReact/components/icons/Icon'
import GroupCard from 'srcReact/components/common2/GroupCard'
import AnchorLink from 'srcReact/components/common2/AnchorLink'

function CTANewGroup() {
  const { t } = useTranslation()
  const [interests, setInterests] = useState([])
  const [groupInfo, setGroupInfo] = useState(null)
  const [remainingCount, setRemainingCount] = useState()
  const [isExpanded, setIsExpanded] = useState(false)

  const {
    common: { isNative },
    feedHome: { ctas }
  } = useSelector((state) => state)

  useEffect(() => {
    if (ctas?.a_new_group?.length > 0) {
      setGroupInfo(ctas.a_new_group[0])
      if (ctas.a_new_group[0].common_interests?.length > 0) {
        const count = ctas.a_new_group[0].common_interests?.length
        setRemainingCount(count - 4)
        setInterests(ctas.a_new_group[0].common_interests)
      }
    }
  }, [ctas?.a_new_group])

  const expandInterests = () => {
    setIsExpanded(true)
    setRemainingCount(0)
  }
  const collapseInterests = () => {
    setIsExpanded(false)
    setRemainingCount(interests.length - 4)
  }

  return ctas?.a_new_group?.length > 0 ? (
    <CTAWrapper title={t('feedCTAs.matchingNewGroupInterest')}>
      <div className={styles.newGroupWrapper}>
        <div className={styles.commonInterests}>
          {interests.length > 0 &&
            interests.map((interest, index) => {
              if ((!isExpanded && index < 4) || isExpanded) {
                return <Pill text={interest.name} selected={true} />
              }
            })}
          {interests.length > 4 ? (
            remainingCount > 0 && !isExpanded ? (
              <button className={styles.remainingCountWrapper} onClick={expandInterests}>
                <span>{`+${remainingCount}`}</span>
                <Icon name='arrow-right' size='large24' />
              </button>
            ) : (
              <button className={styles.remainingCountWrapper} onClick={collapseInterests}>
                <span>{interests.length}</span>
                <Icon name='arrow-left24' size='large24' />
              </button>
            )
          ) : null}
        </div>
        {groupInfo && (
          <div className={styles.groupWrapper}>
            <AnchorLink
              path={`/0/home/group/${groupInfo.group_id}`}
              className={styles.groupLink}
              backNavigation={true}
              isNative={isNative}>
              <GroupCard g={groupInfo} groupTitleClassName={styles.groupCardTitle} />
            </AnchorLink>
          </div>
        )}
      </div>
    </CTAWrapper>
  ) : null
}

export default CTANewGroup
